export function Icon({ name, className = "h-5 w-5" }) {
  const p = { fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" };
  const shapes = {
    shield: <path {...p} d="M12 3 5 6v6c0 4.5 3 7.5 7 9 4-1.5 7-4.5 7-9V6l-7-3Z" />,
    building: <><path {...p} d="M4 20h16M6 20V7h8v13M14 11h4v9M9 10h2M9 14h2" /></>,
    sites: <path {...p} d="M4 18V8l6-3 6 3v10M10 18v-5h4v5M16 11h4v7" />,
    user: <><path {...p} d="M12 12a3.5 3.5 0 1 0-3.5-3.5A3.5 3.5 0 0 0 12 12Z" /><path {...p} d="M5 19.5a7 7 0 0 1 14 0" /></>,
    id: <><rect {...p} x="4" y="5" width="16" height="14" rx="2" /><path {...p} d="M8 10h4M8 14h8" /></>,
    check: <path {...p} d="m5 12 5 5L19 7" />,
    login: <path {...p} d="M10 7V5h9v14h-9v-2M13 12H4m0 0 3-3m-3 3 3 3" />,
    clock: <><circle {...p} cx="12" cy="12" r="8" /><path {...p} d="M12 8v5l3 2" /></>,
    logout: <path {...p} d="M14 7V5H5v14h9v-2M11 12h9m0 0-3-3m3 3-3 3" />,
    qr: <path {...p} d="M5 5h5v5H5zM14 5h5v5h-5zM5 14h5v5H5zM14 14h2v2M18 14v5M14 18h2" />,
    badge: <><rect {...p} x="7" y="3" width="10" height="14" rx="2" /><path {...p} d="M9 20h6" /></>,
    flow: <path {...p} d="M4 7h6l3 5h7M6 17h12" />,
    bell: <path {...p} d="M6 16h12l-1.5-2V10a4.5 4.5 0 0 0-9 0v4L6 16ZM10 16a2 2 0 0 0 4 0" />,
    alert: <path {...p} d="M12 4 3 19h18L12 4Z M12 10v4M12 16h.01" />,
    layers: <path {...p} d="m12 4 8 4-8 4-8-4 8-4Zm-8 8 8 4 8-4M4 16l8 4 8-4" />,
    bank: <path {...p} d="M4 10h16M6 10v8M10 10v8M14 10v8M18 10v8M3 18h18M12 4 3 9h18L12 4Z" />,
    gov: <path {...p} d="M5 19h14M7 19V10M12 19V10M17 19V10M4 10h16L12 5 4 10Z" />,
    factory: <path {...p} d="M3 19V9l5 3V9l5 3V8l8 4v7H3Z" />,
    tower: <path {...p} d="M12 3v18M8 7l4-2 4 2M9 12h6M8 19h8" />,
  };
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true">{shapes[name]}</svg>;
}
